/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import get from 'lodash/get';
import {
    makeAsyncReducer,
    asyncDefaults,
    mergeReducers,
} from 'ui-lottery/src/utils/async_utils';
import * as types from '../constants/actions';
import { FacilityDefaults } from '../props';

const fetchFacilityByIdOrSlug = makeAsyncReducer(types.FETCH_FACILITY_BY_ID_OR_SLUG);

const facilityByIdOrSlug = mergeReducers(
    asyncDefaults(FacilityDefaults),
    types.PP_PREFIX,
    fetchFacilityByIdOrSlug
);

export default facilityByIdOrSlug;

export const selectors = {
    getFacilityByIdOrSlug: (state) => get(state, 'parkpass.facilityByIdOrSlug.data', []),
};
